/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit} from '@angular/core';

@Component({
  templateUrl: './shell.component.html'
})
export class ShellComponent {

  constructor() { }

}
